import api from "@/shared/http/api-client";

export const VertexAiService = {
  getAiResponse(data) {
    return api.post("/vertex/ai_response", data);
  },

  uploadFiles(formData) {
    return api.post("/vertex/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getMetadataConfig() {
    return api.get("/vertex/metadata-config");
  },

  getCourses(tenantId) {
    return api.get(`/vertex/courses/${tenantId}`);
  },

  sync(type, target = "platform") {
    const normalizedTarget =
      String(target).toLowerCase() === "help" ? "help" : "platform";
    return api.get(`/vertex/sync/${type}`, {
      params: { target: normalizedTarget },
    });
  },

  generatePresignedURL(uri) {
    return api.post("/vertex/url", { uri });
  },

  listDocuments() {
    return api.get("/vertex/documents");
  },

  deleteDocument(filePath) {
    return api.delete(
      `/vertex/documents?filePath=${encodeURIComponent(filePath)}`,
    );
  },

  listMetadataFiles() {
    return api.get("/vertex/metadata-files");
  },

  getMetadataContent(fileName) {
    return api.get(
      `/vertex/metadata-files/${encodeURIComponent(fileName)}`,
    );
  },

  updateMetadataFile(fileName, entries) {
    return api.put(
      `/vertex/metadata-files/${encodeURIComponent(fileName)}`,
      { entries },
    );
  },

  listDocumentsWithMetadata() {
    return api.get(
      `/vertex/documents-with-metadata?t=${new Date().getTime()}`,
    );
  },

  getDocumentMetadata(filePath) {
    return api.get(
      `/vertex/documents/metadata?filePath=${encodeURIComponent(filePath)}`,
    );
  },

  updateDocumentMetadata(filePath, metadata) {
    return api.put(
      `/vertex/documents/metadata?filePath=${encodeURIComponent(filePath)}`,
      { metadata },
    );
  },
};

export default VertexAiService;
